import { Box } from '@chakra-ui/react';
import { Table } from '@melio/penny';
import { Vendor } from '@melio/platform-api';

import { MIN_AMOUNT_TO_REQUIRE_INVOICE } from '../utils';
import { AddInvoiceIndictor } from './AddInvoiceIndicator';

type VendorsTabAmountInputCellProps = {
  value?: string;
  vendor: Vendor;
  onAmountChange: (vendor: Vendor, value: string) => void;
  onAddInvoiceClick: (vendorId: Vendor['id'], amount?: string) => void;
};

export const VendorsTabAmountInputCell = ({
  value,
  vendor,
  onAmountChange,
  onAddInvoiceClick,
}: VendorsTabAmountInputCellProps) => {
  const shouldDisplayAddInvoiceIndicator = Number(value) >= MIN_AMOUNT_TO_REQUIRE_INVOICE;

  const handleAddInvoiceClick = () => {
    onAddInvoiceClick(vendor.id, value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue !== value) {
      onAmountChange(vendor, newValue);
    }
  };

  return (
    <Table.Cell onClick={(event) => event.stopPropagation()} data-testid={`vendors-tab-amount-input-cell-${vendor.id}`}>
      {shouldDisplayAddInvoiceIndicator ? (
        <AddInvoiceIndictor onAddInvoiceClick={handleAddInvoiceClick} vendorId={vendor.id} />
      ) : (
        <Box minWidth="24px" />
      )}
      <Table.AmountInput
        data-testid={`vendors-tab-amount-input-${vendor.id}`}
        testKey={vendor.id}
        value={value}
        onChange={handleChange}
        allowNegativeValue={false}
      />
    </Table.Cell>
  );
};
